



















































































































































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { PartnerBannerDraft } from "@/admin/types";
import { Validator } from "vee-validate";
import Carousel from "@/shared/components/Carousel.vue";
import { useBannerStore } from "@/shared/store/banner";
import { PartnerBanner } from "@/shared/types";
import moment from "moment/moment";

@Component({
  components: {
    Carousel
  }
})
export default class BannerForm extends Vue {
  @Prop() partnerId: number;
  @Prop({ default: null }) readonly banner!: PartnerBannerDraft | null;

  $validator!: Validator;
  bannerStore = useBannerStore();

  isSubmitting = false;

  form: PartnerBannerDraft = {
    bannerId: undefined,
    partnerId: undefined,
    carouselOrder: undefined,
    titleA: "",
    titleB: "",
    linkUrl: "",
    linkText: "",
    description: "",
  };

  linkDestinationValidator = {
    getMessage (): string {
      return "Must Be a valid url or the variable %%WEXLINKURL%%";
    },
    validate (input: string) {
      const httpRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-a-zA-Z0-9()@:%_+.~#?&/=]*$/;
      const regex = /^[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-a-zA-Z0-9()@:%_+.~#?&/=]*$/;
      const isUrl = regex.test(input) || httpRegex.test(input);
      const isWexLinkUrl = input === "%%WEXLINKURL%%";
      return isUrl || isWexLinkUrl;
    }
  };

  get isEdit () {
    return !!this.banner && !!this.banner.bannerId;
  }

  mounted () {
    this.$validator.extend("linkDestinationValidator", this.linkDestinationValidator);
    if (this.banner) {
      this.form = { ...this.form, ...this.banner };
    }
  }

  onBack () {
    this.$emit("back");
  }

  submit () {
    this.isSubmitting = true;
    this.$validator.validateAll().then((valid: boolean) => {
      if (valid) {
        if (this.isEdit) {
          this.bannerStore.updatePartnerBanner(
              Number(this.partnerId),
              this.form.bannerId,
              {...this.form} as PartnerBanner
          ).then(() => {
            this.onBack();
          });
        } else {
          this.bannerStore.createPartnerBanner(
              Number(this.partnerId),
              { ...this.form }
          ).then(() => {
            this.onBack();
          });
        }
      }
    }).finally(() => {
      this.isSubmitting = false;
    });
  }
}
